import React from "react";
import { ToDateJalali } from "../../Function";

const ConfirmTimes = ({ form, setform, isApp }) => {
  if (form.checkValidate && form.checkValidate.status === "Success") {
    return (
      <div className="col mt-5">
        <h4 className="text-center">مدیر مجموعه عزیز</h4>
        <p className="text-center wrapTxt">
          تایم های انتخاب شده آماده رزرو قراردادی هستند لطفا ثبت قرار داد را
          کلیک کنید
        </p>
      </div>
    );
  }
  return (
    <div className="col mt-5">
      <h4 className="text-center">مدیر مجموعه عزیز</h4>
      <p className="text-center wrapTxt">
        تایم های زیر توسط کاربران رزرو شدند و قرارداد شما بدون این تایم های
        میباشد در صورت مورد تایید بودن روی ثبت قرارداد کلیک کنید در غیر این صورت
        دکمه برگشت را کلیک کنید
      </p>
      <div
        className={isApp && "row mt-3"}
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: isApp && "column",
        }}
      >
        {form &&
          form.checkValidate &&
          form.checkValidate.times.map((time, key) => {
            return (
              <div className={isApp ? "col-4 fw300 all-nfs-12" : "mx-2"} style={{ flex: !isApp && "0 0 125px" }}>
                <div
                  className={"border p-2 mb-2 "}
                  style={{
                    borderWidth: 1,
                    borderRadius: 5,
                    // padding: WidthPercent(2),
                    // borderColor: Color.primary,
                    // marginRight: WidthPercent(2),
                  }}
                  key={key}
                >
                  <div style={{ textAlign: "center", fontSize: 16 }}>
                    {ToDateJalali(time.date)}
                  </div>
                  <div
                    style={{
                      textAlign: "center",
                      fontSize: 15,
                      //   color: Color.textSecondry,
                    }}
                  >{`${time.start} تا ${time.end}`}</div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default ConfirmTimes;
